import _ from 'lodash';
import produce from 'immer';
import create from 'zustand';

const useAdvertisingsStore = create(set => ({
  advertisings: [],
  removeAdvertising: adToRemove => set(produce(state => {
    state.advertisings = _.remove(state.advertisings, ad => ad.id !== adToRemove.id);
  })),
  set: fn => set(produce(fn)),
}));

export default useAdvertisingsStore;
